/* ÄGAPĒ wireframe torus-knot background.
   Initializes every canvas[data-agape-torus] on the page, sized to its
   parent. Mirrors the festival site's scene: dual-layer wireframe knot,
   slow spin, pointer parallax. Paused offscreen; skipped entirely for
   prefers-reduced-motion (callers should also hide the canvas via CSS). */
import * as THREE from './agape-three.module.min.js';

const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function initTorus(canvas) {
  const wrap = canvas.parentElement;
  const opacity = parseFloat(canvas.dataset.opacity || '0.07');
  const renderer = new THREE.WebGLRenderer({
    canvas,
    alpha: true,
    antialias: false,
    powerPreference: 'low-power',
  });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5));

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(55, 1, 0.1, 100);
  camera.position.set(0, 0, 7);

  const outer = new THREE.Group();
  const spin = new THREE.Group();
  outer.add(spin);
  scene.add(outer);

  const knot = new THREE.Mesh(
    new THREE.TorusKnotGeometry(2.5, 0.5, 150, 20),
    new THREE.MeshBasicMaterial({ color: 0xffffff, wireframe: true, transparent: true, opacity: opacity })
  );
  const ghost = new THREE.Mesh(
    new THREE.TorusKnotGeometry(2.5, 0.5, 80, 12),
    new THREE.MeshBasicMaterial({ color: 0x888888, wireframe: true, transparent: true, opacity: opacity * 0.45 })
  );
  ghost.scale.setScalar(1.04);
  spin.add(knot);
  spin.add(ghost);

  let pointerX = 0;
  let pointerY = 0;
  window.addEventListener('pointermove', (e) => {
    pointerX = (e.clientX / window.innerWidth) * 2 - 1;
    pointerY = -((e.clientY / window.innerHeight) * 2 - 1);
  }, { passive: true });

  function resize() {
    const w = wrap.clientWidth;
    const h = wrap.clientHeight;
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
  }
  resize();
  window.addEventListener('resize', resize);

  let visible = false;
  new IntersectionObserver((entries) => {
    visible = entries[0].isIntersecting;
  }, { rootMargin: '100px 0px' }).observe(wrap);

  let last = performance.now();
  renderer.setAnimationLoop((now) => {
    const delta = Math.min((now - last) / 1000, 0.1);
    last = now;
    if (!visible) return;
    spin.rotation.y += delta * 0.05;
    spin.rotation.x += delta * 0.025;
    outer.rotation.x += (pointerY * 0.08 - outer.rotation.x) * 0.02;
    outer.rotation.y += (pointerX * 0.08 - outer.rotation.y) * 0.02;
    // Scroll parallax: drift the knot vertically against scroll direction
    // as the section moves through the viewport.
    const rect = wrap.getBoundingClientRect();
    const progress = 1 - (rect.top + rect.height / 2) / (window.innerHeight / 2 + rect.height / 2);
    outer.position.y += (progress * 1.6 - outer.position.y) * 0.06;
    renderer.render(scene, camera);
  });
}

if (!reduced) {
  document.querySelectorAll('canvas[data-agape-torus]').forEach((canvas) => {
    try {
      initTorus(canvas);
    } catch (e) {
      canvas.remove();
    }
  });
}
